import { forwardRef, ReactNode } from 'react';
import MuiMenuItem, { MenuItemProps as MuiMenuItemProps } from '@mui/material/MenuItem';
import Stack from '../Stack';

export interface MenuItemProps extends MuiMenuItemProps {
  startIcon?: ReactNode;
  endIcon?: ReactNode;
}

const MenuItem = forwardRef<HTMLLIElement, MenuItemProps>((props, ref) => {
  const { startIcon, endIcon, children, ...otherProps } = props;
  return (
    <MuiMenuItem ref={ref} {...otherProps}>
      <Stack direction="row" alignItems="center" gap={1} width={'100%'}>
        {startIcon && (
          <Stack direction="row" alignItems="center" gap={0.5}>
            {startIcon}
          </Stack>
        )}
        <>{children}</>
        {endIcon && (
          <Stack direction="row" alignItems="center" gap={0.5} sx={{ ml: 'auto' }}>
            {endIcon}
          </Stack>
        )}
      </Stack>
    </MuiMenuItem>
  );
});

MenuItem.displayName = 'MenuItem';

export default MenuItem;
